import { render, staticRenderFns } from "./RegisteredEnrollments.vue?vue&type=template&id=4d3beaaa&scoped=true&"
import script from "./RegisteredEnrollments.vue?vue&type=script&lang=js&"
export * from "./RegisteredEnrollments.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredEnrollments.vue?vue&type=style&index=0&id=4d3beaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3beaaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
